import {FilterObject} from "../filters/filter-object";
import {Component, EventEmitter, Input, Output} from "@angular/core";

@Component({
  selector: 'vos-filtres-panel',
  templateUrl: './vos-filtres-panel.component.html'
})
export class VosFiltresPanelComponent {

  @Input() titre: string;
  @Input() filtres: Array<FilterObject<any>>;
  @Output() onRemove: EventEmitter<FilterObject<any>> = new EventEmitter<FilterObject<any>>();

  constructor() {
  }

  remove(filtre: FilterObject<any>): void {
    this.onRemove.emit(filtre);
  }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-common-module/src/components/filter/vos-filtres-panel/vos-filtres-panel.component.ts